import { Container, ContainerProps } from "semantic-ui-react";

export function BPContainer(props: ContainerProps)  {
    return <Container {...props}>{props.children}</Container>
}